import { jsx as _jsx } from "react/jsx-runtime";
import { useQuery } from '@apollo/client';
import { PaymentRequestStatusTag } from '@src/components/PaymentRequestStatusTag';
import { GET_PAYMENT_REQUEST_STATUS_HISTORY } from '@src/graphql/queries/paymentRequest';
import { getFullName } from '@src/utilities/nameHelper';
import { DataTable, useLocale } from 'pe-core-frontend';
/**
 * PaymentRequestStatusHistory component displays the history of status changes
 * for a given payment request. It fetches and displays the updated status,
 * the timestamp of each update, and the user who made the change in a table.
 *
 * @component
 * @param {PaymentRequestStatusHistoryProps} props - The component props
 * @param {PaymentRequestClaim} props.paymentRequest - The payment request for which to display status history
 *
 * @returns {JSX.Element} DataTable displaying the status history records
 */
export const PaymentRequestStatusHistory = ({ paymentRequest, }) => {
    const { t, formatToLocalDatetime } = useLocale();
    const { data } = useQuery(GET_PAYMENT_REQUEST_STATUS_HISTORY, {
        variables: { id: paymentRequest.id },
    });
    const statusHistory = data?.getPaymentRequestStatusHistory;
    return (_jsx(DataTable, { rows: statusHistory || [], columns: [
            {
                field: 'updatedAt',
                headerName: t('Updated'),
                flex: 0.2,
                renderCell: ({ row }) => formatToLocalDatetime(row.updatedAt, { dateStyle: 'medium', timeStyle: 'short' }),
            },
            {
                field: 'updatedBy',
                headerName: t('By'),
                flex: 0.2,
                renderCell: ({ row }) => (row.updatedBy ? getFullName(row.updatedBy) : '-'),
            },
            {
                field: 'newStatus',
                headerName: t('Status'),
                flex: 0.2,
                renderCell: ({ row }) => (_jsx(PaymentRequestStatusTag, { paymentRequest: { ...paymentRequest, status: row.newStatus }, separateInReviewState: true })),
            },
        ], hideFooterPagination: true, localeText: {
            noRowsLabel: t('No status history found'),
        } }));
};
